var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center",attrs:{"aria-roledescription":"separator"}},[_c('span',{staticClass:"divider"}),_c('span',{staticClass:"date-area"},[_vm._v(_vm._s(_vm.parsedDate))]),_c('span',{staticClass:"divider"})])}
var staticRenderFns = []

export { render, staticRenderFns }